import * as z from 'zod';
import { ASSESSMENT_TYPES, PEER_CATEGORIES, REVIEW_TYPES } from '@/modules/shared/hr-form-engine';

const assessmentKeys = ASSESSMENT_TYPES.map((type) => type.key) as [string, ...string[]];
const reviewKeys = REVIEW_TYPES.map((type) => type.key) as [string, ...string[]];
const categoryKeys = PEER_CATEGORIES.map((category) => category.key) as [string, ...string[]];

export const formBasicInfoSchema = z
  .object({
    Title: z.string().trim().min(1, { message: 'TITLE_REQUIRED' }),
    Description: z.string().optional().default(''),
    AssessmentType: z.enum(assessmentKeys),
    ReviewType: z.enum(reviewKeys),
    Category: z.enum(categoryKeys).optional(),
    IsAllDepartments: z.boolean().default(false),
    DepartmentIds: z.array(z.string()).default([]),
    IsAllDesignations: z.boolean().default(false),
    DesignationIds: z.array(z.string()).default([]),
    ConfirmationForIntern: z.boolean().default(false),
  })
  .superRefine((values, ctx) => {
    if (values.ReviewType === 'peer' && !values.Category) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['Category'], message: 'CATEGORY_REQUIRED' });
    }
    if (!values.IsAllDepartments && values.DepartmentIds.length === 0) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['DepartmentIds'], message: 'DEPARTMENT_REQUIRED' });
    }
    if (!values.IsAllDesignations && values.DesignationIds.length === 0) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['DesignationIds'], message: 'DESIGNATION_REQUIRED' });
    }
  });

export type FormBasicInfoValues = z.input<typeof formBasicInfoSchema>;
export type FormBasicInfoOutput = z.output<typeof formBasicInfoSchema>;
